<div class="banner-container" [ngClass]="[type]">
  <div class="row-layout" [class.justify-center]="justify === 'center'">
    <div class="banner-content">
      @if (showIcon) {
        <span class="banner-icon">
          <hyperkit-icon
            [icon]="getIconClass()"
            size="base"
            [color]="type"
          ></hyperkit-icon>
        </span>
      }
      @if (text) {
        <hyperkit-typography
          variant="body"
          size="md"
          color="primary"
          class="banner-text"
          >{{ text }}</hyperkit-typography
        >
      }
      <ng-content></ng-content>
    </div>

    <div class="banner-actions">
      @if (actionText) {
        <hyperkit-button
          variant="link"
          size="small"
          color="secondary"
          [text]="actionText"
          (click)="onAction()"
        ></hyperkit-button>
      }

      @if (closable) {
        <hyperkit-button
          variant="icon"
          size="small"
          color="tertiary"
          icon="x"
          (click)="onClose()"
        ></hyperkit-button>
      }
    </div>
  </div>
